module.exports = __webpack_public_path__ + "img/RocketOutlined.0d95f269.svg";